var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionStatusActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-subscription-status-active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscription-status-active",
    clipPath: "url(#clip-subscription-status-active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22071",
    "data-name": "Group 22071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19601",
    "data-name": "Group 19601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18810",
    "data-name": "Group 18810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7241",
    "data-name": "Group 7241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6994",
    "data-name": "Group 6994"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24017",
    "data-name": "Rectangle 24017",
    width: 20,
    height: 20,
    rx: 10,
    fill: "#36c451"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18508",
    "data-name": "Path 18508",
    d: "M101.312,58.085h0a.38.38,0,0,1-.291-.132l-2-2.172a.394.394,0,0,1,.583-.53l1.722,1.867,4.768-4.754a.384.384,0,0,1,.556,0,.4.4,0,0,1,0,.556l-5.059,5.046A.361.361,0,0,1,101.312,58.085Z",
    transform: "translate(-93.314 -45.1)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionStatusActive);
export default __webpack_public_path__ + "static/media/subscription-status-active.1f8cbc3de2accce129ea6ce1b5d727cd.svg";
export { ForwardRef as ReactComponent };